import Dexie, { type Table } from "dexie"

/* Each table mirrors a server-owned resource. The shape is intentionally loose
 * (Record<string, unknown>) because the migration is incremental — typed
 * schemas land per-resource as their pages are converted. */

export interface MutationQueueRow {
  id?: number
  resource: string
  action: "create" | "update" | "destroy" | string
  client_uuid: string
  payload: Record<string, unknown>
  created_at: number
  attempts: number
  last_error: string | null
}

export interface MetaRow {
  key: string
  value: unknown
}

export class FocusFlowDB extends Dexie {
  tasks!: Table<Record<string, unknown>, number>
  events!: Table<Record<string, unknown>, number>
  projects!: Table<Record<string, unknown>, number>
  reminders!: Table<Record<string, unknown>, number>
  habit_trackers!: Table<Record<string, unknown>, number>
  alerts!: Table<Record<string, unknown>, number>
  user_preferences!: Table<Record<string, unknown>, string>
  mutation_queue!: Table<MutationQueueRow, number>
  meta!: Table<MetaRow, string>

  constructor() {
    super("focusflow")
    this.version(1).stores({
      tasks: "id, project_id, completed_at, due_at, updated_at",
      events: "id, project_id, start_at, updated_at",
      projects: "id, status, updated_at",
      reminders: "id, project_id, remind_at, dismissed_at, updated_at",
      habit_trackers: "id, project_id, last_checked_in_at, updated_at",
      alerts: "id, alert_type, dismissed_at, snoozed_until, updated_at",
      user_preferences: "key, updated_at",
      mutation_queue: "++id, resource, created_at",
      meta: "key",
    })
  }
}

export const db = new FocusFlowDB()
